import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import "./HDImpactSidebar.css";

const HDImpactSidebar = ({
  onGenderChange,
  onAgeRangeChange,
  onStateChange,
  onDistrictChange,
  onOperatingStateChange,
  onOperatingDistrictChange,
  onProjectNameChange
}) => {
  const [filters, setFilters] = useState({
    gender: [],
    ageRange: [],
    homeState: [],
    homeDistrict: [],
    operatingState: [],
    operatingDistrict: [],
    projectName: []
  });

  const [options, setOptions] = useState({
    gender: [],
    ageRange: [],
    homeState: [],
    homeDistrict: [],
    operatingState: [],
    operatingDistrict: [],
    projectName: []
  });

  const [loading, setLoading] = useState(false);

  const genderLabelMap = { M: "Male", F: "Female", O: "Others" };

  // Fetch filter options dynamically
  const fetchFilterOptions = async (appliedFilters = {}) => {
    try {
      setLoading(true);
      const res = await axios.post(
        "https://api-sales-insights.haqdarshak.com/api/hd-impact/filter-options",
        appliedFilters
      );
      const data = res.data || {};

      setOptions({
        gender: (data.gender || [])
          .filter((val) => ["M", "F", "O"].includes(val))
          .map((val) => ({ value: val, label: genderLabelMap[val] })),

        ageRange: (data.ageRange || []).map((val) => ({ value: val, label: val })),
        homeState: (data.homeState || []).map((val) => ({ value: val, label: val })),
        homeDistrict: (data.homeDistrict || []).map((val) => ({ value: val, label: val })),
        operatingState: (data.operatingState || []).map((val) => ({ value: val, label: val })),
        operatingDistrict: (data.operatingDistrict || []).map((val) => ({ value: val, label: val })),
        projectName: (data.projectName || []).map((val) => ({ value: val, label: val }))
      });
    } catch (err) {
      console.error("Filter fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const handleChange = (key, selectedOptions) => {
    const updatedFilters = { ...filters, [key]: selectedOptions || [] };
    setFilters(updatedFilters);

    const apiFilters = {
      gender: updatedFilters.gender.map((o) => o.value),
      ageRange: updatedFilters.ageRange.map((o) => o.value),
      homeState: updatedFilters.homeState.map((o) => o.value),
      homeDistrict: updatedFilters.homeDistrict.map((o) => o.value),
      operatingState: updatedFilters.operatingState.map((o) => o.value),
      operatingDistrict: updatedFilters.operatingDistrict.map((o) => o.value),
      projectName: updatedFilters.projectName.map((o) => o.value)
    };

    // Fetch dependent filters
    fetchFilterOptions(apiFilters);

    // Trigger parent updates
    if (key === "homeState") onStateChange && onStateChange(apiFilters.homeState);
    if (key === "homeDistrict") onDistrictChange && onDistrictChange(apiFilters.homeDistrict);
    if (key === "operatingState" && onOperatingStateChange)
      onOperatingStateChange(apiFilters.operatingState);
    if (key === "operatingDistrict" && onOperatingDistrictChange)
      onOperatingDistrictChange(apiFilters.operatingDistrict);
    if (key === "gender") onGenderChange && onGenderChange(apiFilters.gender);
    if (key === "ageRange") onAgeRangeChange && onAgeRangeChange(apiFilters.ageRange);
    if (key === "projectName") onProjectNameChange && onProjectNameChange(apiFilters.projectName);
  };

  const clearAllFilters = () => {
    const emptyFilters = {
      gender: [],
      ageRange: [],
      homeState: [],
      homeDistrict: [],
      operatingState: [],
      operatingDistrict: [],
      projectName: []
    };
    setFilters(emptyFilters);
    fetchFilterOptions({});

    // Reset parents
    onGenderChange([]);
    onAgeRangeChange([]);
    onStateChange([]);
    onDistrictChange([]);
    onOperatingStateChange([]);
    onOperatingDistrictChange([]);
    onProjectNameChange([]);
  };

  return (
    <div className="hd-impact-sidebar">
      <h2 className="hd-impact-sidebar-header">HD Impact Filters</h2>

      <FilterSelect
        label="Project"
        options={options.projectName}
        value={filters.projectName}
        onChange={(val) => handleChange("projectName", val)}
        loading={loading}
      />
      <FilterSelect
        label="Home State"
        options={options.homeState}
        value={filters.homeState}
        onChange={(val) => handleChange("homeState", val)}
        loading={loading}
      />
      <FilterSelect
        label="Home District"
        options={options.homeDistrict}
        value={filters.homeDistrict}
        onChange={(val) => handleChange("homeDistrict", val)}
        loading={loading}
      />
      <FilterSelect
        label="Operating State"
        options={options.operatingState}
        value={filters.operatingState}
        onChange={(val) => handleChange("operatingState", val)}
        loading={loading}
      />
      <FilterSelect
        label="Operating District"
        options={options.operatingDistrict}
        value={filters.operatingDistrict}
        onChange={(val) => handleChange("operatingDistrict", val)}
        loading={loading}
      />
      <FilterSelect
        label="Gender"
        options={options.gender}
        value={filters.gender}
        onChange={(val) => handleChange("gender", val)}
        loading={loading}
      />
      <FilterSelect
        label="Age Range"
        options={options.ageRange}
        value={filters.ageRange}
        onChange={(val) => handleChange("ageRange", val)}
        loading={loading}
      />

      <button className="clear-btn" onClick={clearAllFilters}>
        Clear All Filters
      </button>
    </div>
  );
};

// Reusable Select Component
const FilterSelect = ({ label, options, value, onChange, loading }) => (
  <div className="filter-group">
    <label>{label}</label>
    <Select
      options={options}
      value={value}
      onChange={onChange}
      isMulti
      isClearable
      isLoading={loading}
      closeMenuOnSelect={false}
      classNamePrefix="react-select"
      styles={{
        multiValue: (base) => ({ ...base, whiteSpace: "normal" }),
        multiValueLabel: (base) => ({ ...base, whiteSpace: "normal" }),
        valueContainer: (base) => ({ ...base, flexWrap: "wrap" }),
        menu: (base) => ({ ...base, zIndex: 9999 })
      }}
    />
  </div>
);

export default HDImpactSidebar;